import sendAxios from '@/request/axios.config'
import common from './common'

// ********************* example ***************
/**
 * 请求方法示例
 * @param type  请求类型
 * @param data  入参
 * @param params  用于post请求时url后传参，如果是get请求或不需要url传参则忽略次参数
 * @param success 成功回调
 * @param error 错误回调
 * @param headers 请求头
 * @param requestDataType 请求数据格式
 * @param async 是否异步
 * @param enableAbortRequest  是否可以终止请求
 * @returns {Promise<void>}
 */
/* const example = async ({
  type = 'post',
  data = {},
  params = {},
  success,
  error,
  headers,
  requestDataType = '',
  async = true,
  enableAbortRequest = false
}) => {
  let obj = {
    url: 'XXX',
    type: type,
    data: data,
    params: params,
    success: success,
    error: error,
    headers: headers,
    requestDataType: requestDataType,
    enableAbortRequest: enableAbortRequest
  }
  if (async) {
    sendAxios(obj)
  } else {
    await sendAxios(obj)
  }
} */

let request = {}
let apiList = [...common]

apiList.map(item => {
  request[item.requestName] = async ({
    type = 'post',
    url = '',
    data = {},
    params = {},
    success,
    error,
    headers,
    isDefHeaders = true,
    requestDataType = '',
    responseType = 'json',
    async = true,
    enableAbortRequest = false,
    loading = true
  }) => {
    let obj = {
      url: (item.api && url) ? url : item.api,
      type: type,
      data: data,
      params: params,
      success: success,
      error: error,
      headers: headers,
      isDefHeaders: isDefHeaders,
      requestDataType: requestDataType,
      responseType: responseType,
      enableAbortRequest: enableAbortRequest,
      loading: loading
    }
    if (async) {
      sendAxios(obj)
    } else {
      await sendAxios(obj)
    }
  }
})

export default request



// WEBPACK FOOTER //
// ./src/request/index.js